import React, { useContext } from 'react'
import styles from './ViewForm.module.css'
import { observer } from 'mobx-react-lite'
import { ViewFormContext } from './components/store/store.ViewForm'
import { toJS } from 'mobx'
import ButtonSendForm from '../../components/ButtonSendForm/ButtonSendForm'
import RenderField from '../../components/RenderField/RenderField'
import RenderForm from '../../components/RenderForm/RenderForm'

const ViewForm = observer(() => {
  const viewFormContext = useContext(ViewFormContext)

  return (
    <RenderForm
      DataForm={viewFormContext.formInformations}
      DataFields={viewFormContext.fields}
      isActiveSubmit={true}
    />
  )
})

export default ViewForm
